<template lang="pug">
  validation-observer(ref="obs" v-slot="{ handleSubmit }")
    validation-provider(
      v-if="!noStep"
      rules="required"
      name="Шапка"
      vid="header"
      v-slot="{ errors, valid }"
    )
      shapka-field(
        v-model="data.customer_header"
        noChangedText='«Заказчик»,',
        color='grey lighten-4',
      )
      span.error--text(v-for="error in errors") {{ error }}
    template(v-if="noStep")
      validation-provider(
        rules="required"
        name="ФИО"
        vid="fio"
        v-slot="{ errors, valid }"
      )
        v-text-field(
          v-model.trim="data.customer_contact_full_name"
          label="ФИО"
          :error-messages="errors"
          filled
          rounded
        )
      validation-provider(
        rules="required"
        name="Адрес"
        vid="address"
        v-slot="{ errors, valid }"
      )
        v-text-field(
          v-model.trim="data.address"
          label="Адрес"
          :error-messages="errors"
          filled
          rounded
        )
      validation-provider(
        rules="required"
        name="Телефон"
        vid="phone"
        v-slot="{ errors, valid }"
      )
        maska-field(
          v-model="data.customer_contact_phone"
          type="phone"
          filled
          :error-messages="errors"
          rounded
        )
      validation-provider(
        rules="required|email"
        name="Почта"
        vid="email"
        v-slot="{ errors, valid }"
      )
        v-text-field(
          v-model.trim="data.customer_contact_email"
          label="Email"
          :error-messages="errors"
          filled
          rounded
        )

    v-row.ma-0
        v-btn(
          v-if="!noStep"
          color="error"
          @click="backBtnEvent"
        ) Назад
        v-spacer
        v-btn(
          color="primary"
          :loading="loading"
          @click="next"
        ) {{ nextBtnName }}
</template>
<script>
import shapkaField from '@/modules/PaymentSystem/components/shapkaField.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';

export default {
  components: {
    shapkaField,
    MaskaField,
  },
  props: {
    successCallback: { type: Function, default: () => {} },
    backBtnEvent: { type: Function, default: () => {} },
    nextBtnName: { type: String, default: '' },
    noStep: { type: Boolean, default: false },
  },
  data() {
    return {
      data: {
        customer_header: null,
        customer_contact_full_name: null,
        customer_contact_email: null,
        customer_contact_phone: null,
        address: null,
      },
      loading: false,
    };
  },
  methods: {
    async next() {
      const valid = await this.$refs.obs.validate();
      if (valid) {
        this.loading = true;

        this.successCallback(this.data, this.callback);
      }
    },
    callback() {
      this.loading = false;
    },
  },
};
</script>
